<template>
  <div class="newsletter_outer_container step_01" v-if="!NewsletterFormStep01">
    <div class="lft_section">
      <img
        class="lazysizes_loaded"
        :alt="newsletterPopupDataModal.FirstImageALT"
        :src="newsletterPopupDataModal.FirstImage"
        :aria-label="dataModalImageAriaLabel"
      />
    </div>
    <div class="rgt_section">
      <p class="title">{{ newsletterPopupDataModal.Title }}</p>
      <p class="title_desc">{{ newsletterPopupDataModal.Description }}</p>

      <ul class="newsletter_widget">
        <li
          v-for="(item, innerIndex) in newsletterPopupDataModal.PictoImage"
          :key="innerIndex"
        >
          <img
            :src="item.Image"
            :alt="item.PictoImageALT"
            class="i_icon"
            :aria-label="picoImageAriaLabel"
          />
          <p>{{ item.Title }}</p>
        </li>
      </ul>

      <div id="FormNewsletterWidgetStep1">
        <div class="form_fieldset">
          <div class="fieldset">
            <label for="email">{{
              newsletterPopupDataModal.FieldEmail.Label
            }}</label>
            <input
              id="email"
              :placeholder="newsletterPopupDataModal.FieldEmail.Label"
              required
              type="email"
              v-model="formData.emailAddress"
              :class="this.hasErrorEmail ? 'error' : ''"
              :aria-label="emailAriaLabel"
            />
          </div>
          <div class="fieldset">
            <label for="phone">{{
              newsletterPopupDataModal.FieldPhoneNumber.Label
            }}</label>
            <input
              id="phone"
              :placeholder="newsletterPopupDataModal.FieldPhoneNumber.Label"
              type="number"
              v-model="formData.mobile.mobileNumber"
              :required="isRequired"
              :class="this.hasErrorPhone ? 'error' : ''"
              :aria-label="phoneAriaLabel"
            />
          </div>
        </div>

        <p
          class="gdpr"
          v-html="newsletterPopupDataModal.TermsAndConditions"
        ></p>

        <div class="checkbox_group">
          <div class="fieldgroup">
            <input
              type="checkbox"
              id="subscribeNewsletter"
              v-model="isEmailChecked"
              :aria-label="subscribeNewsletterAriaLabel"
            />
            <label for="subscribeNewsletter">{{
              newsletterPopupDataModal.EmailOption.EmailOptinText
            }}</label>
          </div>
          <div class="fieldgroup">
            <input
              type="checkbox"
              id="subscribeSmsMarketing"
              v-model="isPhoneChecked"
              :aria-label="subscribeSmsMarketingAriaLabel"
            />
            <label for="subscribeSmsMarketing">{{
              newsletterPopupDataModal.SmsOption.SmsOptinText
            }}</label>
          </div>
        </div>

        <p class="gdpr" v-html="newsletterPopupDataModal.PrivacyPolicy"></p>
        <p class="error-message" v-if="hasErrorEmailError">
          {{ errorMessages.requiredEmail }}
        </p>
        <p class="error-message" v-if="hasErrorPhone">
          {{ errorMessages.phoneRequired }}
        </p>

        <button
          class="btn_submit"
          @click.prevent="formSubmitStep01"
          method="post"
          :aria-label="submitButtonAriaLabel"
        >
          {{ newsletterPopupDataModal.ButtonText }}
        </button>
        <p class="gdpr">{{ newsletterPopupDataModal.ConditionsApply }}</p>
      </div>
    </div>
  </div>
  <div
    class="newsletter_outer_container step_02"
    v-else-if="!NewsletterFormStep02"
  >
    <div class="lft_section">
      <img
        class="lazysizes_loaded"
        :alt="newsletterPopupDataModal.SecondImageAlt || 'News Letter Image'"
        :src="newsletterPopupDataModal.SecondImage"
        :aria-label="dataModalImageAriaLabel"
      />
    </div>
    <div class="rgt_section">
      <div id="FormNewsletterWidgetStep2">
        <p class="title">{{ newsletterPopupDataModal.Leve2Title }}</p>
        <p class="title_desc">
          {{ newsletterPopupDataModal.Level2Description }}
        </p>

        <div class="form_fieldset">
          <label class="radio_title">{{
            newsletterPopupDataModal.FieldGender.Label
          }}</label>

          <div class="fieldset radio_group">
            <div
              class="radio_btn"
              v-for="(option, index) in newsletterPopupDataModal.FieldGender
                .Options"
              :key="index"
              :class="{ 'form-group--error': $v.formData.gender.$error }"
            >
              <input
                type="radio"
                :id="'option_' + index"
                :value="option.Label"
                v-model.trim="$v.formData.gender.$model"
                name="civility"
              />
              <label :for="'option_' + index">{{ option.Label }}</label>
            </div>
            <div class="hasError" v-if="!$v.formData.gender.required">
              {{ newsletterPopupDataModal.FieldGender.IdError }}
            </div>
          </div>
        </div>

        <div class="form_fieldset">
          <div
            class="fieldset"
            :class="{ 'form-group--error': $v.formData.firstName.$error }"
          >
            <label for="firstName">{{
              newsletterPopupDataModal.FieldFirstName.Label
            }}</label>
            <input
              class="form__input"
              v-model.trim="$v.formData.firstName.$model"
              id="firstName"
            />
          </div>
          <div class="hasError" v-if="!$v.formData.firstName.required">
            {{ newsletterPopupDataModal.FieldFirstName.IdError }}
          </div>
        </div>

        <div class="form_fieldset">
          <div
            class="fieldset"
            :class="{ 'form-group--error': $v.formData.lastName.$error }"
          >
            <label for="lastName">{{
              newsletterPopupDataModal.FieldLastName.Label
            }}</label>
            <input
              class="form__input"
              v-model.trim="$v.formData.lastName.$model"
              id="lastName"
            />
          </div>
          <div class="hasError" v-if="!$v.formData.lastName.required">
            {{ newsletterPopupDataModal.FieldLastName.IdError }}
          </div>
        </div>

        <div class="fieldset DOB_group">
          <label>{{ newsletterPopupDataModal.FieldBirth.CommonLabel }}</label>

          <div class="fieldset select_group">
            <div
              class="fieldset"
              :class="{ 'form-group--error': $v.date.$error }"
            >
              <select v-model.trim="$v.date.$model">
                <option
                  v-for="(day, index) in days"
                  :disabled="!index"
                  :key="index"
                  :value="index ? day : ''"
                >
                  {{ day }}
                </option>
              </select>
            </div>

            <div
              class="fieldset"
              :class="{ 'form-group--error': $v.month.$error }"
            >
              <select v-model.trim="$v.month.$model" @change="updateDays">
                <option
                  v-for="(month, index) in months"
                  :disabled="!index"
                  :key="index"
                  :value="index ? month : ''"
                >
                  {{ month }}
                </option>
              </select>
            </div>

            <div
              class="fieldset"
              :class="{ 'form-group--error': $v.year.$error }"
            >
              <select v-model.trim="$v.year.$model" @change="updateDays">
                <option
                  v-for="(year, index) in years"
                  :disabled="!index"
                  :key="index"
                  :value="index ? year : ''"
                >
                  {{ year }}
                </option>
              </select>
            </div>
            <div class="fieldset_group">
              <div
                class="hasError"
                v-if="
                  !$v.date.required || !$v.month.required || !$v.year.required
                "
              >
                {{ newsletterPopupDataModal.FieldBirth.IdError }}
              </div>
            </div>
          </div>
        </div>
        <button
          class="button"
          type="submit"
          @click.prevent="formSubmitStep02"
          aria-label="Submit Form"
        >
          {{ newsletterPopupDataModal.LevelTwoButtonText }}
        </button>
        <div class="error-message" v-if="displayError">
          {{ newsletterPopupDataModal.FormLevel2ErrorMessage }}
        </div>
        <br /><br />
        <p class="gdpr">
          {{ newsletterPopupDataModal.RequiredValidationMessage }}
        </p>
      </div>
    </div>
  </div>
  <div
    class="newsletter_outer_container step_03"
    v-else-if="!NewsletterFormStep03"
  >
    <div class="lft_section">
      <img
        class="lazysizes_loaded"
        :alt="newsletterPopupDataModal.SecondImageAlt || 'News Letter Image'"
        :src="newsletterPopupDataModal.SecondImage"
        :aria-label="dataModalImageAriaLabel"
      />
    </div>
    <div class="rgt_section">
      <p class="title">{{ newsletterPopupDataModal.ThankyouTitle }}</p>
      <p class="sub_title">
        {{ newsletterPopupDataModal.ThankyouDescription }}
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import { required } from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  name: 'newsletter-popup-form',

  props: {
    newsletterPopupDataModal: {
      type: Object,
      required: true,
    },
    emailValue: {
      type: String,
      required: false,
    },
    dateTime: {
      type: String,
      default: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-')
        .toLocaleString(),
    },
    dataModalImageAriaLabel:{
      type: String,
      required: false,
      default: 'Newsletter Modal Image',
    },
    picoImageAriaLabel:{
      type: String,
      required: false,
      default: 'PictoImage',
    },
    emailAriaLabel:{
      type: String,
      required: false,
      default: 'email',
    },
    phoneAriaLabel:{
      type: String,
      required: false,
      default: 'Phone',
    },
    subscribeNewsletterAriaLabel:{
      type: String,
      required: false,
      default: 'subscribeNewsletter',
    },
    subscribeSmsMarketingAriaLabel:{
      type: String,
      required: false,
      default: 'subscribeSmsMarketing',
    },
    submitButtonAriaLabel:{
      type: String,
      required: false,
      default: 'Submit button',
    },
  },
  data() {
    return {
      busNameBuyOnline: '',
      buyOnlineModalOpen: false,
      currentVariantId: null,
      errors: [],
      hasErrorEmail: false,
      hasErrorEmailError: false,
      hasErrorPhone: false,
      phonenumber: false,
      isEmailChecked: false,
      isPhoneChecked: false,
      NewsletterFormStep01: false,
      NewsletterFormStep02: false,
      NewsletterFormStep03: false,
      displayError: false,
      date: '',
      month: '',
      year: '',
      days: [],
      months: [],
      years: [],
      currentYear: new Date().getFullYear(),
      startYear: 1900,
      formData: {
        firstName: '',
        lastName: '',
        gender: '',
        language: this.newsletterPopupDataModal.CountryLanguage,
        emailAddress: this.emailValue,
        mobile: {
          mobileNumber: '',
        },
        classification: {
          contactCategory: 'Consumer',
        },
        source: {
          sourceCreationDate: this.dateTime,
          sourceName: 'WSF',
          sourceCampaignType: 'Account',
          sourceLastUpdateDate: this.dateTime,
          sourceLastLoginDate: this.dateTime,
        },
        consents: [
          {
            consentType: 'Email',
            optin: this.newsletterPopupDataModal.EmailConsent,
            consentDate: this.dateTime,
          },
          {
            consentType: 'Profiling',
            optin: this.newsletterPopupDataModal.Profiling,
            consentDate: this.dateTime,
          },
          {
            consentType: 'SMS',
            optin: this.newsletterPopupDataModal.SMS,
            consentDate: this.dateTime,
          },
          {
            consentType: 'Mobile',
            optin: this.newsletterPopupDataModal.Mobile,
            consentDate: this.dateTime,
          },
          {
            consentType: 'DigitalMedia',
            optin: this.newsletterPopupDataModal.DigitalMedia,
            consentDate: this.dateTime,
          },
        ],
      },
      submitStatus: null,
      errorMessages: {
        requiredEmail: this.newsletterPopupDataModal.FieldEmail.IdError,
        phoneRequired: this.newsletterPopupDataModal.FieldPhoneNumber.IdError,
      },
    };
  },
  mounted() {
    this.days = [
      this.newsletterPopupDataModal.FieldBirth.DayLabel,
      ...this.rangeCreate(31, 1),
    ];
    this.months = [
      this.newsletterPopupDataModal.FieldBirth.MonthLabel,
      ...this.rangeCreate(12, 1),
    ];
    this.years = [
      this.newsletterPopupDataModal.FieldBirth.YearLabel,
      ...this.rangeCreate(
        this.currentYear - 15 - this.startYear,
        this.startYear
      ),
    ];
  },
  validations: {
    date: {
      required,
    },
    month: {
      required,
    },
    year: {
      required,
    },
    formData: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      gender: {
        required,
      },
    },
  },
  computed: {
    isRequired() {
      return this.isPhoneChecked;
    },
  },
  methods: {
    rangeCreate(size, startAt = 0) {
      return [...Array(size).keys()].map((i) => i + startAt);
    },
    updateDays() {
      const monthDays = [
        31,
        this.isLeapYear(this.year) ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];
      this.days = [
        this.newsletterPopupDataModal.FieldBirth.DayLabel,
        ...this.rangeCreate(monthDays[this.month - 1], 1),
      ];
      if (this.date > this.days.length - 1) {
        this.date = this.days.length - 1;
      }
    },
    isLeapYear(year = new Date().getFullYear()) {
      if (!year) return;
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    },
    formSubmitStep01() {
      this.hasErrorEmail = true;
      this.hasErrorEmailError = true;
      if (this.isEmailChecked) {
        if (this.isPhoneChecked) {
          if (this.validateEmail()) {
            this.hasErrorEmail = false;
          }
          if (!this.formData.mobile.mobileNumber) {
            this.hasErrorEmailError = false;
            this.hasErrorPhone = true;
            return;
          }
        }
        if (!this.validateEmail()) {
          return;
        }
        this.hasErrorEmail = false;
      } else {
        if (
          this.isPhoneChecked &&
          this.validateEmail() &&
          this.formData.mobile.mobileNumber
        ) {
          this.NewsletterFormStep01 = true;
          return;
        } else if (
          this.isPhoneChecked &&
          !this.formData.mobile.mobileNumber &&
          !this.validateEmail()
        ) {
          this.hasErrorEmail = true;
          this.hasErrorPhone = true;
          return;
        } else if (
          this.isPhoneChecked &&
          !this.formData.mobile.mobileNumber &&
          this.validateEmail()
        ) {
          this.hasErrorEmail = false;
          this.hasErrorPhone = true;
          return;
        } else if (this.validateEmail()) {
          this.hasErrorEmail = false;
          this.hasErrorEmailError = true;
          this.hasErrorPhone = false;
          return;
        }
      }
      if (!this.hasErrorEmail) {
        this.NewsletterFormStep01 = true;
      }
      return;
    } /* end of formSubmitStep01 */,

    errorValuesPush(messageArray) {
      let ErrArrays = [];
      messageArray.length &&
        messageArray.forEach((element) => {
          ErrArrays.push(element);
        });
      this.errors = ErrArrays;
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.formData.emailAddress);
    },
    jsonStringify(e) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const formData = {
        ...this.formData,
        birthDate: `${this.year}-${this.month}-${this.date}`,
      };
      axios
        .post('/' + this.newsletterPopupDataModal.ApiUrl, formData)
        .then((response) => {
          this.response = JSON.stringify(response, null, 2);
          if (response.status == 200) {
		     const dataLayer = window.dataLayer || [];
			  dataLayer.forEach((item, index) => {
				if (item.brand !== undefined) {
					dataLayer[index].uiEmailId = response.headers.get('encryptedemailid'); 
				}
			  }); 
            window.dataLayer.push(this.newsletterPopupDataModal.NewsletterPopupEventProperties);
            this.NewsletterFormStep02 = true;
          } else {
            this.NewsletterFormStep02 = false;
          }
        });
    },

    formSubmitStep02() {
      this.displayError = true;
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.submitStatus = 'ERROR';
        return;
      } else {
        this.displayError = false;
        this.jsonStringify(this.formData);
      }
    },
  },
};
</script>
